import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/$tenantSlug/_layout/report/_layout/offer/_layout")({
    component: OfferLayout,
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.report.offer.title"),
        asActive: true,
    }),
});

function OfferLayout() {
    return <Outlet />;
}
